/**
 * List Type Definitions
 * Defines types for user-created restaurant lists functionality
 */

import { Restaurant } from '@/features/dashboard/pages/restaurants/types/restaurants.types';

export interface List {
  id: string;
  userId: string;
  listType: string;
  listName: string;
  city?: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface ListResponse {
  id: string;
  userId: string;
  listType: string;
  listName: string;
  city?: string | null;
  createdAt: string;
  updatedAt: string;
  itemCount: number;
  creatorName?: string;
}

export interface ListItem {
  id: string;
  listId: string;
  userId: string;
  restaurantId: string;
  createdAt: Date;
}

export interface ListWithItems extends List {
  listItems: ListItemWithRestaurant[];
  creatorName?: string | null;
}

export interface ListItemWithRestaurant extends ListItem {
  restaurant: Restaurant;
}

export interface CreateListRequest {
  listType: string;
  listName: string;
  city?: string;
}

export interface UpdateListRequest {
  listType?: string;
  listName?: string;
  city?: string | null;
}

export interface AddToListRequest {
  listId: string;
  restaurantId: string;
}

export interface RemoveFromListRequest {
  listId: string;
  restaurantId: string;
}

export enum ListType {
  FAVORITES = 'favorites',
  WANT_TO_TRY = 'want_to_try',
  VISITED = 'visited',
  FEATURED = 'featured',
  CUSTOM = 'custom',
}

export interface ListStats {
  totalLists: number;
  totalItems: number;
  listsByType: Record<string, number>;
}